import React from 'react';
import type {ThesaurusNodeDetailsTextValue as GrepDetailsTextValueType} from 'services/thesaurus/types';
import {FlexBox} from 'components/layout';
import {Text, TextArea} from 'components/text';
import {NodeLabel} from './NodeLabel';

type Props = {
  itemKey: string;
  value: GrepDetailsTextValueType;
};

export const GrepDetailsTextValue: React.FC<Props> = ({itemKey, value}) => {
  return (
    <FlexBox>
      <NodeLabel label={itemKey} />
      {value.type === 'text' ? (
        <Text variant="body2">{value.value}</Text>
      ) : (
        <TextArea value={value.value} />
      )}
    </FlexBox>
  );
};
